import React from 'react'

import { MainContent } from 'components/layouts/MainContent/MainContent'

export const DashboardMain = ({ children }) => (
  <MainContent>{children}</MainContent>
)
